import { useMemo } from 'react';
const useQueryParams = () => {
  const search = window.location.search;
  return useMemo(() => Object.fromEntries(new URLSearchParams(search).entries()), [search]);
};
export default useQueryParams;